import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "./CustomLoginForm.css"; // ajoute ton style ici si nécessaire
import logo from "./assets/logofinal-thmb.png";

const LANG_KEY = "weavevo_lang";

const LOGIN_I18N = {
  en: {
    logo_alt: "Weavevo",
    username_label: "Username",
    password_label: "Password",
    login_btn: "Log in",
    google_btn: "Continue with Google",
    no_account: "No account yet?",
    create_account: "Create an account",
    login_failed: "Login failed",
    login_error: "Login error",
  },
  fr: {
    logo_alt: "Weavevo",
    username_label: "Nom d’utilisateur",
    password_label: "Mot de passe",
    login_btn: "Se connecter",
    google_btn: "Continuer avec Google",
    no_account: "Pas encore de compte ?",
    create_account: "Créer un compte",
    login_failed: "Échec de la connexion",
    login_error: "Erreur de connexion",
  },
};

function getLang() {
  if (typeof window === "undefined") return "en";
  const v = (localStorage.getItem(LANG_KEY) || "en").toLowerCase();
  return v === "fr" ? "fr" : "en";
}

const CustomLoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const [lang, setLang] = useState(getLang);

  useEffect(() => {
    const sync = () => setLang(getLang());
    const onStorage = (e) => {
      if (e && e.key && e.key !== LANG_KEY) return;
      sync();
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("weavevo_lang_changed", sync);
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("weavevo_lang_changed", sync);
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);

  const dict = useMemo(() => LOGIN_I18N[lang] || LOGIN_I18N.en, [lang]);
  const t = (k) => dict[k] ?? LOGIN_I18N.en[k] ?? k;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://weavevo.com/auth/realms/master/protocol/openid-connect/token", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          client_id: "weavevo-frontend",
          client_secret: "CaoSHmZcQVz7AVCaY9JwwbNXSUE4ULv2",
          grant_type: "password",
          username,
          password,
          scope: "openid",
        }),
      });

      if (!response.ok) throw new Error(t("login_failed"));

      const data = await response.json();
      const token = data.access_token;
      const payload = JSON.parse(atob(token.split(".")[1]));

      login(token, { name: payload.name, email: payload.email });
      navigate("/public");
    } catch (error) {
      alert(t("login_error"));
      console.error("Erreur login :", error);
    }
  };

  return (
    <div className="login-pf body">
      <div className="login-pf-page">
        <div id="kc-header" className="login-pf-header text-center mb-3">
          <img src={logo} alt={t("logo_alt")} style={{ height: 100 }} />
        </div>

        <div id="kc-content">
          <div id="kc-content-wrapper" className="card p-4 shadow-sm">
            <form onSubmit={handleLogin}>
              <div className="form-group mb-3">
                <label htmlFor="username" className="form-label">
                  {t("username_label")}
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group mb-4">
                <label htmlFor="password" className="form-label">
                  {t("password_label")}
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  {t("login_btn")}
                </button>
              </div>
            </form>

            <hr className="my-4" />
            <div className="text-center">
              <button
                className="btn btn-outline-dark w-100"
                onClick={() =>
                  (window.location.href =
                    "https://weavevo.com/auth/realms/master/protocol/openid-connect/auth?client_id=weavevo-frontend&redirect_uri=https://weavevo.com/auth/callback&response_type=code&scope=openid&kc_idp_hint=google")
                }
              >
                <i className="bi bi-google me-2"></i> {t("google_btn")}
              </button>
            </div>

            <div className="text-center mt-3">
              <span className="text-muted">{t("no_account")} </span>
              <br />
              <a
                href="https://weavevo.com/auth/realms/master/protocol/openid-connect/auth?client_id=weavevo-frontend&redirect_uri=https%3A%2F%2Fweavevo.com%2Fauth%2Fcallback&response_type=code&scope=openid&prompt=create&kc_idp_hint="
                className="text-decoration-none fw-semibold"
              >
                {t("create_account")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoginForm;
